module.exports = "/images/Sell products online.svg?8591a8cb9ff3acad021f389b4112c93c";